// Preenche a assinatura autorizadora nos requerimentos criados antes desta funcionalidade.
// Executa uma única vez por navegador e nunca sobrescreve assinaturas existentes.

import { lumi } from '@/lib/lumi'
import { gerarChaveAssinatura } from '@/utils/chaveAssinatura'
import { nowISO } from '@/utils/masks'

const FLAG = 'protocoleai_assinaturas_migradas_v1'

export async function migrarAssinaturas(): Promise<void> {
  try {
    if (localStorage.getItem(FLAG) === 'ok')
      return
  }
  catch {
    return
  }

  try {
    const protocolos = await (lumi.entities as any).protocolos.list({ limit: 500 })
    const lista: any[] = protocolos?.list || []
    const pendentes = lista.filter(p => !p?.assinaturaAutorizador?.nomeCompleto)
    if (!pendentes.length) {
      try {
        localStorage.setItem(FLAG, 'ok')
      }
      catch { /* silencioso */ }
      return
    }

    const usuarios = await (lumi.entities as any).user_profiles.list({ limit: 500 })
    const porUserId = new Map<string, any>()
    ;(usuarios?.list || []).forEach((u: any) => {
      if (u?.userId)
        porUserId.set(u.userId, u)
    })

    for (const p of pendentes) {
      const dono = porUserId.get(p.requerenteUserId || '') || null
      if (!dono)
        continue

      let chave: string = dono.chaveAssinatura || ''
      if (!chave) {
        chave = await gerarChaveAssinatura(dono.userId || '', dono.cpf || '')
        try {
          await (lumi.entities as any).user_profiles.update(dono._id, { chaveAssinatura: chave })
          dono.chaveAssinatura = chave
        }
        catch {
          /* segue sem gravar no perfil */
        }
      }

      try {
        await (lumi.entities as any).protocolos.update(p._id, {
          assinaturaAutorizador: {
            userId: dono.userId || '',
            nomeCompleto: dono.nomeCompleto || '',
            funcao: dono.funcao || '',
            cpf: dono.cpf || '',
            chave,
            emitidoEm: p.createdAt || nowISO(),
          },
        })
      }
      catch {
        /* continua com os restantes */
      }
    }

    try {
      localStorage.setItem(FLAG, 'ok')
    }
    catch { /* silencioso */ }
  }
  catch {
    /* silencioso — não interrompe a aplicação */
  }
}

/** Garante que o utilizador atual já tem a sua chave única de assinatura. */
export async function garantirChaveUsuario(user: {
  _id?: string
  userId?: string
  cpf?: string
  chaveAssinatura?: string
} | null): Promise<void> {
  if (!user?._id || user.chaveAssinatura || !user.userId)
    return
  try {
    const chave = await gerarChaveAssinatura(user.userId, user.cpf || '')
    await (lumi.entities as any).user_profiles.update(user._id, { chaveAssinatura: chave })
  }
  catch {
    /* silencioso */
  }
}
